import React from 'react';
import { View, StyleSheet, Text } from 'react-native';
import Colors from '../../../constants/Colors';

const ParametersInfoContent = () => <View>
  <Text style={styles.parameterLongName}>{'Temperature:'}</Text>
  <Text style={styles.descriptionText}>
    {'The measure of how hot or cold the air is, which directly impacts comfort levels inside a space.'}
  </Text>
  <Text style={styles.parameterLongName}>{'CO2 (Carbon Dioxide)'}</Text>
  <Text style={styles.descriptionText}>
    {'A gas commonly found in the air. High levels indoors can indicate poor ventilation and may cause discomfort or health issues.'}
  </Text>
  <Text style={styles.parameterLongName}>{'PM2.5 (Particulate Matter 2.5)'}</Text>
  <Text style={styles.descriptionText}>
    {'Larger particles in the air, up to 10 microns. These particles can also affect air quality and health, especially for people with respiratory conditions.'}
  </Text>
  <Text style={styles.parameterLongName}>{'TVOC (Total Volatile Organic Compounds)'}</Text>
  <Text style={styles.descriptionText}>
    {'A group of chemicals that can be harmful to health and are released from things like paints, cleaning supplies, and furniture.'}
  </Text>
  <Text style={styles.parameterLongName}>{'Humidity'}</Text>
  <Text style={styles.descriptionText}>
    {'The amount of moisture in the air. High or low humidity can affect comfort, health, and even the integrity of materials in a building.'}
  </Text>
  <Text style={styles.parameterLongName}>{'Noise'}</Text>
  <Text style={styles.descriptionText}>
    {'The level of sound in the environment. Too much noise can lead to discomfort, stress, and reduced productivity.'}
  </Text>
  <Text style={styles.parameterLongName}>{'Light'}</Text>
  <Text style={styles.descriptionText}>
    {'The amount of illumination in a space, which affects comfort, mood, and productivity.'}
  </Text>
</View>;

const styles = StyleSheet.create({
  parameterLongName: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'Poppins_600SemiBold',
    color: Colors.light.hereworksBlack600,
    marginTop: 16,
    marginBottom: 12,
  },
  descriptionText: {
    fontSize: 14,
    lineHeight: 18,
    fontFamily: 'Roboto_400Regular',
    color: Colors.light.hereworksBlack500,
  },
});

export default ParametersInfoContent;
